export default __webpack_public_path__ + "static/media/item1.c414f611.svg";